import styled, { css } from "styled-components";
import { Colors } from "../config/Constants";
import { TextFont } from "../config";
import { useNavigate } from "react-router-dom";
import ProfileListIcons from "./Topbar/ProfileListIcons";
import { useEffect, useRef } from "react";
import { useIsAuthenticated } from "@azure/msal-react";

const ProfileList = ({
  profileListingData,
  setClose,
  setOpenLogoutModal,
  pageEnd,
}) => {
  const navigate = useNavigate();
  const isAuthenticated = useIsAuthenticated();

  const handleClick = (path) => {
    if (path === "/logout") {
      setOpenLogoutModal(true);
    } else navigate(`/user${path}`);
    setClose(false);
  };

 

  const getEachList = (index, profileList) => {
    return (
      <ProfileListWrapper
        key={index}
        onClick={() => handleClick(profileList.path)}
      >
        <TextFont
          fontColor={Colors.brandOne}
          fontSize="1.125rem"
          fontWeight={600}
        >
          {profileList.label}
        </TextFont>
        <ProfileListIcons path={profileList.iconPath} />
      </ProfileListWrapper>
    );
  };

  return (
    <ProfileListModal pageEnd={pageEnd}>
      {profileListingData.map((profileList, index) => {
        if (profileList.path === "/pin") {
          if (!isAuthenticated) return getEachList(index, profileList);
        } else {
          return getEachList(index, profileList);
        }
      })}
    </ProfileListModal>
  );
};

const ProfileListModal = styled.div`
  background: ${Colors.antiFlashWhite};
  border-radius: 1.375rem;
  position: absolute;
  width: 17.25rem;
  padding: 0.625rem 1.875rem;
  display: flex;
  flex-direction: column;
  z-index: 999;
  box-shadow: 0 0.625rem 0.625rem ${Colors.boxShadow};
  ${(props) =>
    props.pageEnd &&
    css`
      right: 0;
      left: auto;
      margin-top: 0.375rem;
    `}
`;

const ProfileListWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 0.813rem 0rem;
  z-index: 999;
  cursor: pointer;
  border-bottom: 1px solid ${Colors.paleCornflowerBlueOpacity40};
  &:last-child {
    border-bottom: none;
  }
`;

export default ProfileList;
